import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    awsApiToken: null
  },
  mutations: {
    setUser (state, value) {
      state.user = value
    },
    setAwsApiToken (state, value) {
      state.awsApiToken = value
    }
  },
  getters: {
    awsApiToken: state => {
      return state.awsApiToken
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js